module.exports = __webpack_public_path__ + "static/assets/2c3b7928d26e6a043141e479a494d47e.svg";